export const CONTEXT = {
    CLICK_SWIGGY_MONEY_INFO_HALF_CARD_CLOSE_BUTTON: "click-dismiss",
    CLICK_SWIGGY_MONEY_INFO_HALF_CARD_ACTION_BUTTON: "click-ok",
    LINK_WALLET_SOURCE_ACCOUNT: "account",
    LINK_WALLET_SOURCE_PAYMENT: "payment",
    HEADER: "header",
    HALF_CARD: "half-card",
    CLOSE: "close",
    GET_STARTED: "Get-started",
};
